var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "links"
  }), _c('div', {
    staticClass: "copyright"
  }, [_vm._v(" Copyright"), _c('a-icon', {
    attrs: {
      "type": "copyright"
    }
  }), _vm._v(_vm._s(_vm.copyright) + " ")], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };